import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { BaseSchema } from 'yup';
import PaymentMethod from 'model/PaymentMethod';
import {
  CELLPHONE_FR_LENGTH_REGEX,
  CELLPHONE_FR_REGEX,
  CELLPHONE_UK_LENGTH_REGEX,
  CELLPHONE_UK_REGEX,
} from 'settings/regex';

export default (
  t: TFunction,
  methodsAvailable: string[],
  isUk: boolean
): BaseSchema =>
  Yup.object().shape({
    paymentMethod: Yup.string()
      .nullable()
      .required(t('LABEL_PAYMENT_VALIDATION_ERROR_MISSING_PAYMENT_METHOD'))
      .oneOf(
        methodsAvailable,
        t('LABEL_PAYMENT_VALIDATION_ERROR_MISSING_PAYMENT_METHOD')
      ),
    cpa: Yup.boolean().when(['paymentMethod'], {
      is: PaymentMethod.pa,
      then: schema =>
        schema
          .required(t('LABEL_PAYMENT_VALIDATION_ERROR_MISSING_CPA'))
          .oneOf([true], t('LABEL_PAYMENT_VALIDATION_ERROR_MISSING_CPA')),
      otherwise: schema => schema,
    }),
    cellPhone: Yup.string()
      .matches(
        isUk ? CELLPHONE_UK_LENGTH_REGEX : CELLPHONE_FR_LENGTH_REGEX,
        t('LABEL_ERROR_CELLPHONE_NUMBER_LENGTH', { ns: 'signUpPage' })
      )
      .matches(
        isUk ? CELLPHONE_UK_REGEX : CELLPHONE_FR_REGEX,
        t('LABEL_ERROR_CELLPHONE_NUMBER_REGEX', { ns: 'signUpPage' })
      )
      .when(['paymentMethod'], {
        is: PaymentMethod.oney,
        then: schema =>
          schema.required(
            t('LABEL_ERROR_CELLPHONE_REQUIRED', { ns: 'signUpPage' })
          ),
      }),
  });
